import React from 'react';
import './App.css';
import Routes from './Routes';
import { BrowserRouter as Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'mdbreact/dist/css/mdb.css';
import 'antd/dist/antd.css';

const browserHistory = createBrowserHistory();
function App() {

  // console.log(window.location.hostname)
  if(window.location.hostname == 'visa.visaero.com'){
    localStorage.setItem('host','visaero') //visaero visadone
    localStorage.setItem('brand','visaero')
    localStorage.setItem('brand_color','#663785')
  }else if(window.location.hostname == 'visa.visadone.com'){
    localStorage.setItem('host','visadone') //visaero visadone
    localStorage.setItem('brand','visadone')
    localStorage.setItem('brand_color','#2E3192')
  }else if(window.location.hostname == 'visa-vi-stage.visaero.com'){
    localStorage.setItem('host','visaero') //visaero visadone
    localStorage.setItem('brand','visaero')
    localStorage.setItem('brand_color','#663785')
  } else if(window.location.hostname == 'visa-vd-stage.visaero.com'){
    localStorage.setItem('host','visadone') //visaero visadone
    localStorage.setItem('brand','visadone')
    localStorage.setItem('brand_color','#2E3192')
  } else if(window.location.hostname == '192.168.1.16'){
    localStorage.setItem('host','visaero') //visaero visadone
    localStorage.setItem('brand','visaero')
    localStorage.setItem('brand_color','#663785')
  } else if(window.location.hostname == 'localhost'){
    localStorage.setItem('host','visadone') //visaero visadone
    localStorage.setItem('brand','visaero')
    localStorage.setItem('brand_color','#2E3192') //663785  //2E3192
  }
  else{
    localStorage.setItem('host','visaero') //visaero visadone
    localStorage.setItem('brand','visaero')
    localStorage.setItem('brand_color','#663785')
  }

  return (
    <Router history={browserHistory}>
      <Routes />
    </Router>
  );
}

export default App;
